import React, { Component, Fragment } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, MenuItem, FormHelperText, Select, InputLabel,
  TextField, CircularProgress, Accordion, AccordionSummary, AccordionDetails, Button,
  Typography, Box, Stack, IconButton, Tooltip, Grid,
  Card,
  CardMedia,
  CardActions
} from '@mui/material';
import { FaArrowLeft, FaPencilAlt, FaPlus, FaCheck, FaCheckCircle, FaTrash } from "react-icons/fa";
import MyButton from '../../../utils/MyButton';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { editMtoTablaV2, getMtoPrevV2, clearErrors } from '../../../redux/actions/dataactions';
import {getUsuariosAsistenciales} from '../../../redux/actions/useractions';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDropzone } from 'react-dropzone';

const FileDropzone = ({ onFileDrop }) => {
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    },
    maxFiles: 1,
    onDrop: onFileDrop
  });

  return (
    <div className="dropzone-container mt-4">
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p className="dropzone-text">Arrastra y suelta el archivo aquí, o haz clic para seleccionarlo</p>
        <em className="dropzone-info">(Solo se permite subir un archivo PDF, DOC o DOCX)</em>
      </div>

      <aside className="dropzone-preview">
        {fileRejections.length > 0 && (
          <div className="file-error">
            <h4>Solo se puede cargar un archivo</h4>
          </div>
        )}

        {acceptedFiles.length > 0 && (
          <div className="file-accepted-dropzone">
            <h4 className='text-file-dropzone'>Archivo a cargar:</h4>
            <ul className="file-list-dropzone">
              {acceptedFiles.map(file => (
                <li key={file.path} className="file-item-dropzone">
                  {file.path} - {file.size} bytes
                </li>
              ))}
            </ul>
          </div>
        )}
      </aside>
    </div>
  );
};

export class EditarMtoPrev extends Component {
  constructor() {
    super();
    this.state = {
         chasis:false,
        vaccesorios:false,
        vcontroles:false,
        vgeneral:false,
        limpieza:false,
        lelectronica:false,
        pcuantitativa:false,
        selectrica:false,
        lchasis:false,
        lubricacion:false,
        aptouso:true,
        repuestosreq:false,
        reqmtocorr:false,
        bajaequipo:false,
          pruebas: [{
                      instrumento: '',
                      prueba: '',
                      valor: '',
                      valormed: ''
                    }],
        repuestos: [''],
        actividadesprog:'',
        actividadesreal:'',
        observaciones:'',
        horainicio:'',
        horafinal:'',
        firmarecibe:'',
        cargorecibe:'',
        fecha:'',
        fechafinal:'',
      version: '',
      
      errors: {},
      aprobado: {},
      open: false,

        // New fields for reception methods
        metodoRecepcion: 'manual', // default method
        // Digital signature fields
        firmaDigital: null,
        firmaGuardada: false, // Confirmation indicator when signature is saved
        uploadingImage: false, // Control for image uploads
        nombreFirmante: '',
        cargoFirmante: '',
        // User selection fields
        usuarioRecibe: '',
        // Image upload fields
        imagenFirma: null,
        nombreFirmaImagen: '',
        cargoFirmaImagen: '',
        searchQuery: '',
        actividades:'',
        duracion:'',
        hora:'',
        archivoPDF: null,           // nuevo archivo seleccionado (File)
        archivoPDFRemoto: '',       // url del archivo ya guardado en el reporte
        archivoPDFRemotoEliminado: false,

        imagenesAdjuntas: [],       // Files nuevas
        imagenesRemotas: [],        // [{ key:'imagenAdjunta1', url:'...' }, ...]
        imagenesRemotasEliminadas: [],
        progid:''
    };
    this.canvasRef = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI.errors) newState.errors = props.UI.errors;
    if (props.UI.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length > 0 ? newState : null;
  }

  formatearFecha = (fecha) => {
    if (!fecha) return '';
    const partes = fecha.split('/');
    if (partes.length !== 3) return fecha;
    const [dia, mes, año] = partes;
    return `${año}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
  };

  mapUserDetailsToState = (reportemto) => {
    if (!reportemto) return;

    const pruebasNormalizadas = Array.isArray(reportemto.pruebas)
    ? reportemto.pruebas
        .slice(0, 6) // respetar el límite de 6 en la UI
        .map((p) => ({
          instrumento: (p.instrumento ?? '').toString(),
          prueba: (p.prueba ?? '').toString(),
          valor: p.valor != null ? p.valor.toString() : '',
          valormed: p.valormed != null ? p.valormed.toString() : '',
        }))
    : [{
        instrumento: '',
        prueba: '',
        valor: '',
        valormed: ''
      }];

        const archivoPDFRemoto =
        reportemto.archivoPDF || reportemto.archivoAdjunto || reportemto.archivoUrl || '';

        const imagenesRemotas = ['imagenAdjunta1', 'imagenAdjunta2', 'imagenAdjunta3']
        .map((key) => reportemto[key] ? { key, url: reportemto[key] } : null)
        .filter(Boolean);
  
const repuestosNormalizados = (() => {
  // intenta tomar la fuente de repuestos (ajusta el nombre si tu backend usa otro)
  const src = reportemto.repuestos ?? reportemto.Repuestos ?? null;

  let arr = [];
  if (Array.isArray(src)) {
    // caso típico: arreglo ["Repuesto 1", "Repuesto 2", ...]
    arr = src;
  } else if (src && typeof src === 'object') {
    // por si viene como objeto con claves "0","1","2",...
    arr = Object.keys(src)
      .filter(k => /^\d+$/.test(k))
      .sort((a, b) => Number(a) - Number(b))
      .map(k => src[k]);
  }

  // normaliza: toString, máximo 6, y al menos 1 campo vacío
  const out = arr.map(v => (v ?? '').toString()).slice(0, 6);
  return out.length ? out : [''];
})();

 // --- MÉTODO DE RECEPCIÓN ---
  // Si el backend ya manda 'metodoRecepcion', úsalo. Si no, infiérelo por los campos presentes.
  const metodoRecepcion = (() => {
    if (reportemto.metodoRecepcion) return reportemto.metodoRecepcion;
    if (reportemto.firmaDigital) return 'firma';
    if (reportemto.imagenFirma) return 'imagen';
    if (reportemto.usuarioRecibe) return 'usuario';
    if (reportemto.firmarecibe || reportemto.cargorecibe) return 'manual';
    return 'manual';
  })();

    this.setState({
        progid:reportemto.progid, 
      version: reportemto.version ?? '',
      chasis:reportemto.chasis ?? '',
        vaccesorios:reportemto.vaccesorios ?? '',
        vcontroles:reportemto.vcontroles ?? '',
        vgeneral:reportemto.vgeneral ?? '',
        limpieza:reportemto.limpieza ?? '',
        lelectronica:reportemto.lelectronica ?? '',
        pcuantitativa:reportemto.pcuantitativa ?? '',
        selectrica:reportemto.selectrica ?? '',
        lchasis:reportemto.lchasis ?? '',
        lubricacion:reportemto.lubricacion ?? '',
        aptouso:reportemto.aptouso ?? '',
        repuestosreq:reportemto.repuestosreq ?? '',
        reqmtocorr:reportemto.reqmtocorr ?? '',
        bajaequipo:reportemto.bajaequipo ?? '',
         pruebas: pruebasNormalizadas, 
      fecha: reportemto.fecha ? this.formatearFecha(reportemto.fecha) : '',
       actividadesprog:reportemto.actividadesprog ?? '',
        actividadesreal:reportemto.actividadesreal ?? '',
        observaciones:reportemto.observaciones ?? '',
         fechafinal: reportemto.fechafinal ? this.formatearFecha(reportemto.fechafinal) : '',
        horainicio:reportemto.horainicio ?? '',
        horafinal:reportemto.horafinal ?? '',
       
        archivoPDFRemoto,
        archivoPDFRemotoEliminado: false,
        imagenesRemotas,
        imagenesRemotasEliminadas: [],
         repuestos: repuestosNormalizados,
         metodoRecepcion,
    // Manual
    firmarecibe: reportemto.firmarecibe ?? '',
    cargorecibe: reportemto.cargorecibe ?? '',
    // Firma digital (puede ser dataURL o URL)
    firmaDigital: reportemto.imagenfirma ?? null,
    firmaGuardada: Boolean(reportemto.firmaDigital), // para mostrar “firma guardada”
    nombreFirmante: reportemto.firmarecibe ?? '',
    cargoFirmante: reportemto.cargorecibe ?? '',
    // Usuario
    usuarioRecibe: reportemto.usuarioRecibe ?? '',
    // Imagen de firma
    imagenfirma: reportemto.imagenfirma ?? null,
    nombreFirmaImagen: reportemto.nombreFirmaImagen ?? '',
    cargoFirmaImagen: reportemto.cargoFirmaImagen ?? '',
    });
  };

  handleOpen = () => {
    if (this.props.disabled) return; 
    this.setState({ open: true, errors: {}, aprobado: {} });
    this.mapUserDetailsToState(this.props.reportemto);
  };

  handleClose = () => {
    if (this.state.aprobado && this.state.aprobado.mensaje) {
      this.props.getMtoPrevV2(this.props.reportemto.progid);
      this.setState({ open: false, errors: {}, aprobado: {} });
      this.props.clearErrors();
    } else {
      this.props.clearErrors();
      this.setState({ open: false, errors: {}, aprobado: {} });
    }
  };

 componentDidMount() {
  this.mapUserDetailsToState(this.props.reportemto);
  window.addEventListener('resize', this.resizeCanvas);
}

componentDidUpdate(prevProps, prevState) {
  if (prevState.metodoRecepcion !== this.state.metodoRecepcion) {
    if (this.state.metodoRecepcion === 'firma') {
      // evita duplicar listeners
      this.teardownCanvas();

      // Solo inicializa el canvas si NO hay firma guardada
      if (!this.state.firmaDigital) {
        // requestAnimationFrame garantiza que el <canvas> ya está en el DOM
        requestAnimationFrame(() => this.initCanvas());
      }
    } else {
      // saliendo de 'firma' => desmontar listeners del canvas
      this.teardownCanvas();

      if (this.state.metodoRecepcion === 'usuario') {
        this.props.getUsuariosAsistenciales(this.props.clienteId);
      }
    }
  }
}
  
  componentWillUnmount() {
  window.removeEventListener('resize', this.resizeCanvas);
  this.teardownCanvas();
}
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleRemoveFirmaDigital = () => {
  this.setState({ imagenfirma: null, firmaGuardada: false }, () => {
    // Si el método es 'firma', vuelve a mostrar el canvas para capturar una nueva
    if (this.state.metodoRecepcion === 'firma') {
      setTimeout(() => this.initCanvas(), 0);
    }
  });
};

  handleSubmit = (e) => {
  e.preventDefault();

  // 1) Validar/armar receptor (manual, firma, usuario, imagen)
  const receptorInfo = this.buildReceptorInfo();
  if (!receptorInfo) return; // buildReceptorInfo ya deja el error en state

  // 2) Aplanar PRUEBAS igual que en el post
  const pruebasProcesadas = this.state.pruebas.map((p, index) => ({
    [`instrumento${index + 1}`]: p.instrumento,
    [`prueba${index + 1}`]: p.prueba,
    [`valor${index + 1}`]: p.valor,
    [`valormed${index + 1}`]: p.valormed,
  }));

  // 3) Aplanar REPUESTOS igual que en el post (repuesto1..6)
  const repuestosProcesados = this.state.repuestos.reduce((acc, valor, index) => {
    acc[`repuesto${index + 1}`] = valor;
    return acc;
  }, {});

  // 4) Seguridad de límite de imágenes (remotas que quedan + nuevas <= 3)
  const totalImagenes = this.state.imagenesRemotas.length + this.state.imagenesAdjuntas.length;
  if (totalImagenes > 3) {
    this.setState(prev => ({
      errors: { ...prev.errors, imagenesAdjuntas: 'Máximo 3 imágenes (remotas + nuevas).' }
    }));
    return;
  }

  // 5) Construir payload de edición
  const editPayload = {
    version: this.state.version,

    // Checks / actividades
    chasis: this.state.chasis,
    vaccesorios: this.state.vaccesorios,
    vcontroles: this.state.vcontroles,
    vgeneral: this.state.vgeneral,
    limpieza: this.state.limpieza,
    lelectronica: this.state.lelectronica,
    pcuantitativa: this.state.pcuantitativa,
    selectrica: this.state.selectrica,
    lchasis: this.state.lchasis,
    lubricacion: this.state.lubricacion,

    // Descripción
    actividadesprog: this.state.actividadesprog,
    actividadesreal: this.state.actividadesreal,
    observaciones: this.state.observaciones,

    // Fechas/horas
    fecha: this.state.fecha,
    fechafinal: this.state.fechafinal,
    horainicio: this.state.horainicio,
    horafinal: this.state.horafinal,

    // Estado del equipo
    aptouso: this.state.aptouso,
    repuestosreq: this.state.repuestosreq,
    reqmtocorr: this.state.reqmtocorr,
    bajaequipo: this.state.bajaequipo,

    // Repuestos aplanados
    ...repuestosProcesados,

    // Pruebas aplanadas
    ...Object.assign({}, ...pruebasProcesadas),

    // Método de recepción
    ...receptorInfo,

    // Adjuntos:
    // - Solo manda archivo nuevo si el usuario subió uno (el action debe formatearlo como FormData)
    archivoPDF: this.state.archivoPDF || undefined,
    // - Marca si se eliminó el archivo remoto
    archivoPDFRemotoEliminado: this.state.archivoPDFRemotoEliminado || undefined,
    // - Nuevas imágenes (Files)
    imagenesAdjuntas: this.state.imagenesAdjuntas || [],
    // - Cuáles imágenes remotas eliminar (['imagenAdjunta2', ...])
    imagenesRemotasEliminadas: this.state.imagenesRemotasEliminadas || [],
  };

  // 6) IDs y dispatch
  const { credentials } = this.props.user || {};
  const handle =
    credentials?.tipouser === 'Tecnico' ? credentials?.handleuser : credentials?.handle;

  // Ajusta estos IDs según cómo te llegan al componente:
  const equipoId = this.props.equipoId;
  const clienteId = this.props.clienteId;     // si lo tienes en props
  const progMtoId = this.state.progid;     // si lo tienes en props (o donde corresponda)

  // Llama tu acción de edición (renombra a tu action real)
  // Ejemplo: this.props.editMtoPrev(editPayload, equipoId, clienteId, progMtoId, handle);
  this.props.editMtoTablaV2(editPayload, equipoId, clienteId, progMtoId, handle);
};

  
  handleAddPrueba = () => {
  if (this.state.pruebas.length < 6) {
    this.setState(prevState => ({
      pruebas: [...prevState.pruebas, { instrumento: '', prueba: '', valor: '', valormed: '' }]
    }));
      }
    };

    handlePruebaChange = (index, field, value) => {
      const nuevasPruebas = [...this.state.pruebas];
      nuevasPruebas[index][field] = value;
      this.setState({ pruebas: nuevasPruebas });
    };

    handleRemovePrueba = (index) => {
      const nuevasPruebas = [...this.state.pruebas];
      nuevasPruebas.splice(index, 1);
      this.setState({ pruebas: nuevasPruebas });
    };

     handleArchivoDrop = (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        this.setState({ archivoPDF: acceptedFiles[0] });
      }
    };

      
      handleRemoveImagen = (index) => {
        const nuevas = [...this.state.imagenesAdjuntas];
        nuevas.splice(index, 1);
        this.setState({ imagenesAdjuntas: nuevas });
      };

    handleRemoveImagenRemota = (index) => {
  const { imagenesRemotas, imagenesRemotasEliminadas } = this.state;
  const eliminada = imagenesRemotas[index];
  const restantes = [...imagenesRemotas];
  restantes.splice(index, 1);
  this.setState({
    imagenesRemotas: restantes,
    imagenesRemotasEliminadas: eliminada?.key
      ? [...imagenesRemotasEliminadas, eliminada.key]
      : imagenesRemotasEliminadas
  });
};

        handleRemoveArchivoRemoto = () => {
        this.setState({ archivoPDFRemoto: '', archivoPDFRemotoEliminado: true });
        };

        // Limitar nuevas imágenes según cuántas remotas queden
        handleImagenesSeleccionadas = (event) => {
        const archivos = Array.from(event.target.files);
        const cupo = 3 - this.state.imagenesRemotas.length;
        const permitidas = archivos.slice(0, cupo);
        const nuevasImagenes = [...this.state.imagenesAdjuntas, ...permitidas].slice(0, 3);
        this.setState({ imagenesAdjuntas: nuevasImagenes });
        };

      handleAddRepuesto = () => {
  if (this.state.repuestos.length < 6) {
    this.setState((prevState) => ({
      repuestos: [...prevState.repuestos, '']
    }));
  }
};

handleRemoveRepuesto = (index) => {
  const nuevos = [...this.state.repuestos];
  nuevos.splice(index, 1);
  this.setState({ repuestos: nuevos });
};

handleRepuestoChange = (index, value) => {
  const nuevos = [...this.state.repuestos];
  nuevos[index] = value;
  this.setState({ repuestos: nuevos });
};

 // Initialize the canvas for signature
teardownCanvas = () => {
  const canvas = this.canvasRef && this.canvasRef.current;
  if (!canvas) return;

  canvas.removeEventListener('mousedown', this.startDrawing);
  canvas.removeEventListener('mousemove', this.draw);
  canvas.removeEventListener('mouseup', this.stopDrawing);
  canvas.removeEventListener('mouseout', this.stopDrawing);

  canvas.removeEventListener('touchstart', this.startDrawingTouch);
  canvas.removeEventListener('touchmove', this.drawTouch);
  canvas.removeEventListener('touchend', this.stopDrawing);
};

  initCanvas = () => {
  const canvas = this.canvasRef?.current;
  if (!canvas) return;

  // Limpia listeners previos por si acaso
  this.teardownCanvas();

  const ctx = canvas.getContext('2d');

  this.resizeCanvas(); // también re-hace el fondo blanco

  // Estado de dibujo
  this.isDrawing = false;
  this.lastX = 0;
  this.lastY = 0;

  // Listeners
  canvas.addEventListener('mousedown', this.startDrawing);
  canvas.addEventListener('mousemove', this.draw);
  canvas.addEventListener('mouseup', this.stopDrawing);
  canvas.addEventListener('mouseout', this.stopDrawing);

  canvas.addEventListener('touchstart', this.startDrawingTouch, { passive: false });
  canvas.addEventListener('touchmove', this.drawTouch, { passive: false });
  canvas.addEventListener('touchend', this.stopDrawing);
};

  // Resize canvas to fit container
  resizeCanvas = () => {
    if (!this.canvasRef.current) return;
    
    const canvas = this.canvasRef.current;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const container = canvas.parentElement;
    
    canvas.width = container.clientWidth * ratio;
    canvas.height = 200 * ratio;
    canvas.style.width = `${container.clientWidth}px`;
    canvas.style.height = "200px";
    
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    
    // Set drawing styles
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'black';
    
    // Fill with white background
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  // Start drawing
  startDrawing = (e) => {
    const canvas = this.canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    this.isDrawing = true;
    this.lastX = e.clientX - rect.left;
    this.lastY = e.clientY - rect.top;
  }

  // Handle touch start
  startDrawingTouch = (e) => {
    e.preventDefault();
    if (e.touches.length !== 1) return;
    
    const touch = e.touches[0];
    const canvas = this.canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    
    this.isDrawing = true;
    this.lastX = touch.clientX - rect.left;
    this.lastY = touch.clientY - rect.top;
  }

  // Draw on the canvas
  draw = (e) => {
    if (!this.isDrawing) return;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    
    const currentX = e.clientX - rect.left;
    const currentY = e.clientY - rect.top;
    
    ctx.beginPath();
    ctx.moveTo(this.lastX, this.lastY);
    ctx.lineTo(currentX, currentY);
    ctx.stroke();
    
    this.lastX = currentX;
    this.lastY = currentY;
  }

  // Handle touch move
  drawTouch = (e) => {
    e.preventDefault();
    if (!this.isDrawing || e.touches.length !== 1) return;
    
    const touch = e.touches[0];
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    
    const currentX = touch.clientX - rect.left;
    const currentY = touch.clientY - rect.top;
    
    ctx.beginPath();
    ctx.moveTo(this.lastX, this.lastY);
    ctx.lineTo(currentX, currentY);
    ctx.stroke();
    
    this.lastX = currentX;
    this.lastY = currentY;
  }

  // Stop drawing
  stopDrawing = () => {
    this.isDrawing = false;
  }

  // Clear digital signature
  clearSignature = () => {
    if (!this.canvasRef.current) return;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Clear canvas
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    this.setState({ firmaDigital: null });
  }

  // Check if canvas is empty
  isCanvasEmpty = () => {
    if (!this.canvasRef.current) return true;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    
    // Check if all pixel data is white (255, 255, 255, 255)
    for (let i = 0; i < pixelData.length; i += 4) {
      // Check RGB values (skip alpha)
      if (pixelData[i] !== 255 || pixelData[i + 1] !== 255 || pixelData[i + 2] !== 255) {
        return false; // Found a non-white pixel
      }
    }
    
    return true; // Canvas is empty (all white)
  }

  // Save digital signature
  saveSignature = () => {
    if (!this.canvasRef.current) return;
    
    if (!this.isCanvasEmpty()) {
      const signatureData = this.canvasRef.current.toDataURL('image/png');
      
      // Save signature and set firmaGuardada to true
      this.setState({ 
        firmaDigital: signatureData,
        firmaGuardada: true, // Visual indicator that the signature was saved
        errors: {
          ...this.state.errors,
          firmaDigital: null
        }
      });
      
      // Show confirmation message that disappears after a few seconds
      setTimeout(() => {
        this.setState({ firmaGuardada: false });
      }, 3000);
    } else {
      // Show error - empty signature
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          firmaDigital: "Es necesario firmar antes de guardar"
        }
      }));
    }
  }

  // Handle image upload
  handleImageButtonClick = () => {
    // Create a temporary file input
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    
    // Set up the event handler before activating the input
    fileInput.addEventListener('change', (event) => {
      const file = event.target.files[0];
      if (file) {
        this.setState({ uploadingImage: true });
        
        const reader = new FileReader();
        
        reader.onload = (e) => {
          this.setState({ 
            imagenFirma: e.target.result,
            uploadingImage: false,
            errors: {
              ...this.state.errors,
              imagenFirma: null
            }
          });
        };
        
        reader.onerror = () => {
          this.setState({ 
            uploadingImage: false,
            errors: {
              ...this.state.errors,
              imagenFirma: "Error al cargar la imagen"
            }
          });
        };
        
        reader.readAsDataURL(file);
      }
    });
    
    // Simulate clicking the input
    fileInput.click();
  }

  // Get user info by ID from props
  getUserInfo = (userId, field) => {
    const { usuariosAsistenciales } = this.props.user;
    
    if (!usuariosAsistenciales) return '';
    
    const user = usuariosAsistenciales.find(u => u.idUsuario === userId);
    
    // If the field is 'cargo' but doesn't exist, provide a default value
    if (field === 'cargo' && (!user || !user[field])) {
      return 'Asistencial';
    }
    
    return user ? user[field] : '';
  }

  buildReceptorInfo = () => {
  const { metodoRecepcion } = this.state;

  switch (metodoRecepcion) {
    case 'manual':
      return {
        firmarecibe: this.state.firmarecibe,
        cargorecibe: this.state.cargorecibe,
        metodoRecepcion: 'manual'
      };

    case 'firma': {
      // 1) Si ya hay firma guardada (de backend o de una sesión previa), úsala
      if (this.state.firmaDigital) {
        return {
          nombreFirmante: this.state.nombreFirmante,
          cargoFirmante: this.state.cargoFirmante,
          firmaDigital: this.state.firmaDigital,
          metodoRecepcion: 'firma'
        };
      }
      // 2) Si no, intenta tomarla del canvas
      if (this.canvasRef?.current && !this.isCanvasEmpty()) {
        const signatureData = this.canvasRef.current.toDataURL('image/png');
        return {
          nombreFirmante: this.state.nombreFirmante,
          cargoFirmante: this.state.cargoFirmante,
          firmaDigital: signatureData,
          metodoRecepcion: 'firma'
        };
      }
      // 3) Error si no hay firma
      this.setState((prev) => ({
        errors: { ...prev.errors, firmaDigital: 'Es necesario firmar antes de guardar' }
      }));
      return null;
    }

    case 'usuario':
      if (this.state.usuarioRecibe) {
        return { usuarioRecibe: this.state.usuarioRecibe, metodoRecepcion: 'usuario' };
      }
      this.setState((prev) => ({
        errors: { ...prev.errors, usuarioRecibe: 'Debe seleccionar un usuario' }
      }));
      return null;

    case 'imagen':
      if (this.state.imagenFirma) {
        return {
          nombreFirmaImagen: this.state.nombreFirmaImagen,
          cargoFirmaImagen: this.state.cargoFirmaImagen,
          imagenFirma: this.state.imagenFirma,
          metodoRecepcion: 'imagen'
        };
      }
      this.setState((prev) => ({
        errors: { ...prev.errors, imagenFirma: 'Se requiere una imagen de firma' }
      }));
      return null;

    default:
      return {
        firmarecibe: this.state.firmarecibe,
        cargorecibe: this.state.cargorecibe,
        metodoRecepcion: 'manual'
      };
  }
};

 // Method selection change handler
  handleMethodChange = (event) => {
    const method = event.target.value;
    this.setState({ metodoRecepcion: method });
    
    // If user selection is chosen, load the list of healthcare users
    if (method === 'usuario') {
      this.props.getUsuariosAsistenciales(this.props.clienteId);
    }
  }
  render() {
    const { UI: { loading } } = this.props;
    const { errors } = this.state;

    return (
      <div>
        <Fragment>
         {this.props.disabled ? (
           <Tooltip title="Cierra el PDF para habilitar la edición">
            <span>
               <MyButton tip="Editar Reporte" onClick={this.handleOpen} disabled>
               <FaPencilAlt color="#03178C" className="icon-crearcliente" />
              </MyButton>
            </span>
           </Tooltip>
         ) : (
           <MyButton tip="Editar Reporte" onClick={this.handleOpen}>
             <FaPencilAlt color="#03178C" className="icon-crearcliente" />
          </MyButton>
         )}

          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            fullWidth
            maxWidth="sm"
          >
            {this.state.aprobado.mensaje ? (
              <div className='div-aprobado'>
                <div className='div-icono-aprobado'>
                  <FaCheck color="#ffffff" className='icono-aprobado' />
                </div>
                <h2 className='text-aprobado'>Reporte Editado Exitosamente</h2>
              </div>
            ) : (
              <div>
                <DialogTitle>
                                <Typography sx={{ 
                                                 fontSize: '20px', 
                                                 fontWeight: 600, 
                                                 color: '#0468BF', 
                                                 textAlign: 'center' 
                                                 }}>
                                                 Editar Mantenimiento Preventivo
                                 </Typography>
                             </DialogTitle>

                <DialogContent>
                <form>
                    <Accordion>
                                         <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1a-content"
                                      id="panel1a-header"
                                    >
                                      <Typography sx={{
                                        color: '#0468BF',
                                        fontSize: '18px',
                                        fontWeight: 400,
                                        ml: 1,
                                      }}>
                                        Actividades Realizadas
                                      </Typography>
                                    </AccordionSummary>
                                        <AccordionDetails>
                                                        <Grid container spacing={2}>
                                                              {/* Primera fila */}
                                                              <Grid item xs={12} md={6}>
                                                                <FormControl fullWidth variant="outlined" size="small">
                                                                  <InputLabel>Inspección Chásis</InputLabel>
                                                                  <Select
                                                                    required
                                                                    name="chasis"
                                                                    value={this.state.chasis}
                                                                    onChange={this.handleChange}
                                                                    label="Inspección Chásis"
                                                                  >
                                                                    <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                                    <MenuItem value={true}>Sí</MenuItem>
                                                                    <MenuItem value={false}>N/A</MenuItem>
                                                                  </Select>
                                                                  <FormHelperText>{errors.chasis}</FormHelperText>
                                                                </FormControl>
                                                              </Grid>
                                                        
                                                              <Grid item xs={12} md={6}>
                                                                <FormControl fullWidth variant="outlined" size="small">
                                                                  <InputLabel>Verificar Accesorios</InputLabel>
                                                                  <Select
                                                                    required
                                                                    name="vaccesorios"
                                                                    value={this.state.vaccesorios}
                                                                    onChange={this.handleChange}
                                                                    label="Verificar Accesorios"
                                                                  >
                                                                    <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                                    <MenuItem value={true}>Sí</MenuItem>
                                                                    <MenuItem value={false}>N/A</MenuItem>
                                                                  </Select>
                                                                  <FormHelperText>{errors.vaccesorios}</FormHelperText>
                                                                </FormControl>
                                                              </Grid>
                                                        
                                                              {/* Segunda fila */}
                                                              <Grid item xs={12} md={6}>
                                                                <FormControl fullWidth variant="outlined" size="small">
                                                                  <InputLabel>Verificar Controles</InputLabel>
                                                                  <Select
                                                                    required
                                                                    name="vcontroles"
                                                                    value={this.state.vcontroles}
                                                                    onChange={this.handleChange}
                                                                    label="Verificar Controles"
                                                                  >
                                                                    <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                                    <MenuItem value={true}>Sí</MenuItem>
                                                                    <MenuItem value={false}>N/A</MenuItem>
                                                                  </Select>
                                                                  <FormHelperText>{errors.vcontroles}</FormHelperText>
                                                                </FormControl>
                                                              </Grid>
                                                        
                                                              <Grid item xs={12} md={6}>
                                                                <FormControl fullWidth variant="outlined" size="small">
                                                                  <InputLabel>Prueba Cuantitativa</InputLabel>
                                                                  <Select
                                                                    required
                                                                    name="pcuantitativa"
                                                                    value={this.state.pcuantitativa}
                                                                    onChange={this.handleChange}
                                                                    label="Prueba Cuantitativa"
                                                                  >
                                                                    <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                                    <MenuItem value={true}>Sí</MenuItem>
                                                                    <MenuItem value={false}>N/A</MenuItem>
                                                                  </Select>
                                                                  <FormHelperText>{errors.pcuantitativa}</FormHelperText>
                                                                </FormControl>
                                                              </Grid>
                                                        
                                                              {/* Tercera fila */}
                                                              <Grid item xs={12} md={6}>
                                                                <FormControl fullWidth variant="outlined" size="small">
                                                                  <InputLabel>Pruebas Electricas</InputLabel>
                                                                  <Select
                                                                    required
                                                                    name="selectrica"
                                                                    value={this.state.selectrica}
                                                                    onChange={this.handleChange}
                                                                    label="Pruebas Electricas"
                                                                  >
                                                                    <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                                    <MenuItem value={true}>Sí</MenuItem>
                                                                    <MenuItem value={false}>N/A</MenuItem>
                                                                  </Select>
                                                                  <FormHelperText>{errors.selectrica}</FormHelperText>
                                                                </FormControl>
                                                              </Grid>
                                                        
                                                              <Grid item xs={12} md={6}>
                                                                <FormControl fullWidth variant="outlined" size="small">
                                                                  <InputLabel>Limpieza</InputLabel>
                                                                  <Select
                                                                    required
                                                                    name="limpieza"
                                                                    value={this.state.limpieza}
                                                                    onChange={this.handleChange}
                                                                    label="Limpieza"
                                                                  >
                                                                    <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                                    <MenuItem value={true}>Sí</MenuItem>
                                                                    <MenuItem value={false}>N/A</MenuItem>
                                                                  </Select>
                                                                  <FormHelperText>{errors.limpieza}</FormHelperText>
                                                                </FormControl>
                                                              </Grid>
                                                        
                                                              {/* Cuarta fila */}
                                                              <Grid item xs={12} md={6}>
                                                                <FormControl fullWidth variant="outlined" size="small">
                                                                  <InputLabel>Lubricación de Partes</InputLabel>
                                                                  <Select
                                                                    required
                                                                    name="lubricacion"
                                                                    value={this.state.lubricacion}
                                                                    onChange={this.handleChange}
                                                                    label="Lubricación de Partes"
                                                                  >
                                                                    <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                                    <MenuItem value={true}>Sí</MenuItem>
                                                                    <MenuItem value={false}>N/A</MenuItem>
                                                                  </Select>
                                                                  <FormHelperText>{errors.lubricacion}</FormHelperText>
                                                                </FormControl>
                                                              </Grid>
                                                        
                                                              <Grid item xs={12} md={6}>
                                                                <FormControl fullWidth variant="outlined" size="small">
                                                                  <InputLabel>Limpieza Electrónica</InputLabel>
                                                                  <Select
                                                                    required
                                                                    name="lelectronica"
                                                                    value={this.state.lelectronica}
                                                                    onChange={this.handleChange}
                                                                    label="Limpieza Electrónica"
                                                                  >
                                                                    <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                                    <MenuItem value={true}>Sí</MenuItem>
                                                                    <MenuItem value={false}>N/A</MenuItem>
                                                                  </Select>
                                                                  <FormHelperText>{errors.lelectronica}</FormHelperText>
                                                                </FormControl>
                                                              </Grid>
                                                        
                                                              {/* Quinta fila */}
                                                              <Grid item xs={12} md={6}>
                                                                <FormControl fullWidth variant="outlined" size="small">
                                                                  <InputLabel>Limpieza de Chásis</InputLabel>
                                                                  <Select
                                                                    required
                                                                    name="lchasis"
                                                                    value={this.state.lchasis}
                                                                    onChange={this.handleChange}
                                                                    label="Limpieza de Chásis"
                                                                  >
                                                                    <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                                    <MenuItem value={true}>Sí</MenuItem>
                                                                    <MenuItem value={false}>N/A</MenuItem>
                                                                  </Select>
                                                                  <FormHelperText>{errors.lchasis}</FormHelperText>
                                                                </FormControl>
                                                              </Grid>
                                                        
                                                              <Grid item xs={12} md={6}>
                                                                <FormControl fullWidth variant="outlined" size="small">
                                                                  <InputLabel>Verificación General</InputLabel>
                                                                  <Select
                                                                    required
                                                                    name="vgeneral"
                                                                    value={this.state.vgeneral}
                                                                    onChange={this.handleChange}
                                                                    label="Verificación General"
                                                                  >
                                                                    <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                                    <MenuItem value={true}>Sí</MenuItem>
                                                                    <MenuItem value={false}>N/A</MenuItem>
                                                                  </Select>
                                                                  <FormHelperText>{errors.vgeneral}</FormHelperText>
                                                                </FormControl>
                                                              </Grid>
                                                            </Grid>
                                                          </AccordionDetails>
                                      </Accordion>


<Accordion>
                   <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        ml: 1,
                      }}>
                        Mediciones Realizadas
                      </Typography>
                    </AccordionSummary>
                   <AccordionDetails>
                              {this.state.pruebas.map((prueba, index) => (
                    <Fragment key={index}>
                      <Grid item xs={12} md={3} mt={1}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          label={`Instrumento ${index + 1}`}
                          value={prueba.instrumento}
                          onChange={(e) => this.handlePruebaChange(index, 'instrumento', e.target.value)}
                          error={Boolean(errors[`instrumento${index + 1}`])}
                          helperText={errors[`instrumento${index + 1}`]}
                        />
                      </Grid>

                      <Grid item xs={12} md={3} mt={1}>
                        <FormControl fullWidth variant="outlined" size="small" error={Boolean(errors[`prueba${index + 1}`])}>
                          <InputLabel>Variable</InputLabel>
                          <Select
                            value={prueba.prueba}
                            onChange={(e) => this.handlePruebaChange(index, 'prueba', e.target.value)}
                            label="Variable"
                          >
                            <MenuItem value=""><em>Seleccionar</em></MenuItem>
                            <MenuItem value="velocidad">Velocidad</MenuItem>
                            <MenuItem value="energia">Energía</MenuItem>
                            <MenuItem value="flujo">Flujo</MenuItem>
                            <MenuItem value="nibp">NIBP</MenuItem>
                            <MenuItem value="peep">PEEP</MenuItem>
                            <MenuItem value="presion">Presión</MenuItem>
                            <MenuItem value="relacionie">Relación I:E</MenuItem>
                            <MenuItem value="ecg">ECG</MenuItem>
                            <MenuItem value="temperatura">Temperatura</MenuItem>
                            <MenuItem value="peso">Peso</MenuItem>
                            <MenuItem value="fio2">FIO2</MenuItem>
                            <MenuItem value="volumen">Volumen</MenuItem>
                            <MenuItem value="spo2">Spo2</MenuItem>
                            <MenuItem value="frecuencia">Frecuencia</MenuItem>
                            <MenuItem value="dB">dB</MenuItem>
                            <MenuItem value="etco2">EtCO2</MenuItem> 
                            <MenuItem value="co2inspirado">CO2 Inspirado</MenuItem>
                            <MenuItem value="frecuenciarespiratoria">Frecuencia Respiratoria</MenuItem>
                            <MenuItem value="frecuenciacardiaca">Frecuencia Cardíaca</MenuItem>
                            <MenuItem value="IBP">Presión Invasiva</MenuItem>
                            <MenuItem value="presionpico">Presión Pico</MenuItem>
                            <MenuItem value="corriente">Corriente (A)</MenuItem>
                            <MenuItem value="voltaje">Voltaje (V)</MenuItem>
                            <MenuItem value="potencia">Potencia (W)</MenuItem>
                            <MenuItem value="resistencia">Resistencia (Ohm)</MenuItem>
                            <MenuItem value="frecuenciaelectrica">Frecuencia Eléctrica (Hz)</MenuItem>
                            <MenuItem value="ph">pH</MenuItem>
                            <MenuItem value="pco2">PCO2</MenuItem>
                            <MenuItem value="po2">PO2</MenuItem>
                            <MenuItem value="concentraciongas">Concentración de Gas</MenuItem>
                            <MenuItem value="tiemporespuesta">Tiempo de Respuesta</MenuItem>
                            <MenuItem value="linealidad">Linealidad</MenuItem>
                            <MenuItem value="exactitud">Exactitud</MenuItem>
                            <MenuItem value="precision">Precisión</MenuItem>
                          </Select>
                           <FormHelperText>{errors[`prueba${index + 1}`]}</FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={2} mt={1}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="Valor Referencia"
                          value={prueba.valor}
                          onChange={(e) => this.handlePruebaChange(index, 'valor', e.target.value)}
                          error={Boolean(errors[`valor${index + 1}`])}
                          helperText={errors[`valor${index + 1}`]}
                        />
                      </Grid>

                      <Grid item xs={12} md={2} mt={1}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="Valor Medido"
                          value={prueba.valormed}
                          onChange={(e) => this.handlePruebaChange(index, 'valormed', e.target.value)}
                          error={Boolean(errors[`valormed${index + 1}`])}
                          helperText={errors[`valormed${index + 1}`]}
                        />
                      </Grid>

                      <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Tooltip title="Eliminar prueba">
                          <IconButton color="error" onClick={() => this.handleRemovePrueba(index)}>
                            <FaTrash />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Fragment>
                  ))}

                  {this.state.pruebas.length < 6 && (
                      <Grid item xs={12}>
                        <Button
                          variant="outlined"
                          startIcon={<FaPlus />}
                          onClick={this.handleAddPrueba}
                        >
                          Agregar Prueba
                        </Button>
                      </Grid>
                    )}
                                   </AccordionDetails>
                  </Accordion>

 <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3a-content"
                      id="panel3a-header"
                    >
                      <Typography sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        ml: 1,
                      }}>
                        Descripcion de Actividades
                      </Typography>
                    </AccordionSummary>
                   <AccordionDetails>
                     <Grid container spacing={2}>
                                         <Grid item xs={12} mt={1}>
                                           <TextField
                                             fullWidth
                                             multiline
                                             rows={4}
                                             variant="outlined"
                                             size="small"
                                             label="Actividades Programadas"
                                             name="actividadesprog"
                                             value={this.state.actividadesprog}
                                             onChange={this.handleChange}
                                             error={Boolean(errors.actividadesprog)}
                                             helperText={errors.actividadesprog}
                                           />
                                         </Grid>
                                       </Grid>

                    <Grid container spacing={2}>
                                         <Grid item xs={12} mt={1}>
                                           <TextField
                                             fullWidth
                                             multiline
                                             rows={4}
                                             variant="outlined"
                                             size="small"
                                             label="Actividades Realizadas"
                                             name="actividadesreal"
                                             value={this.state.actividadesreal}
                                             onChange={this.handleChange}
                                             error={Boolean(errors.actividadesreal)}
                                             helperText={errors.actividadesreal}
                                           />
                                         </Grid>
                                       </Grid>
                                   <Grid container spacing={2}>
                                         <Grid item xs={12} mt={1}>
                                           <TextField
                                             fullWidth
                                             multiline
                                             rows={4}
                                             variant="outlined"
                                             size="small"
                                             label="Observaciones"
                                             name="observaciones"
                                             value={this.state.observaciones}
                                             onChange={this.handleChange}
                                             error={Boolean(errors.observaciones)}
                                             helperText={errors.observaciones}
                                           />
                                         </Grid>
                                       </Grid>
                                   </AccordionDetails>
                  </Accordion>


                  <Accordion>
                                           <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel3a-content"
                                        id="panel3a-header"
                                      >
                                        <Typography sx={{
                                          color: '#0468BF',
                                          fontSize: '18px',
                                          fontWeight: 400,
                                          ml: 1,
                                        }}>
                                          Archivos Adjuntos
                                        </Typography>
                                      </AccordionSummary>
                                         <AccordionDetails>
                                        {/* ==== Archivo adjunto del reporte (si existe) ==== */}
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                            <Typography variant="subtitle2" sx={{ color: '#0468BF', fontSize: '16px', fontWeight: 400, ml: 1 }}>
                                                Archivo adjunto del reporte
                                            </Typography>

                                            {this.state.archivoPDFRemoto ? (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1, ml: 1 }}>
                                                <a href={this.state.archivoPDFRemoto} target="_blank" rel="noreferrer">
                                                    Ver archivo
                                                </a>
                                                <Tooltip title="Eliminar archivo del reporte">
                                                    <IconButton color="error" onClick={this.handleRemoveArchivoRemoto}>
                                                    <FaTrash />
                                                    </IconButton>
                                                </Tooltip>
                                                </Box>
                                            ) : (
                                                <Typography variant="body2" sx={{ ml: 1, mt: 1 }}>
                                                No hay archivo registrado en el reporte.
                                                </Typography>
                                            )}
                                            </Grid>

                                            {/* ==== Subir nuevo archivo PDF/DOC/DOCX ==== */}
                                            <Grid item xs={12}>
                                            <Typography variant="subtitle2" sx={{ color: '#0468BF', fontSize: '16px', fontWeight: 400, ml: 1 }}>
                                                Adjuntar archivo PDF, DOC o DOCX
                                            </Typography>
                                            <FileDropzone onFileDrop={this.handleArchivoDrop} />
                                            </Grid>
                                        </Grid>

                                        {/* ==== Imágenes del reporte (remotas) ==== */}
                                        <Grid item xs={12} sx={{ mt: 2 }}>
                                            <Typography variant="subtitle2" sx={{ color: '#0468BF', fontSize: '16px', fontWeight: 400, ml: 1 }}>
                                            Imágenes del reporte
                                            </Typography>

                                            <Grid container spacing={2} sx={{ mt: 0.5 }}>
                                            {this.state.imagenesRemotas.length === 0 && (
                                                <Grid item xs={12}>
                                                <Typography variant="body2" sx={{ ml: 1 }}>
                                                    No hay imágenes registradas en el reporte.
                                                </Typography>
                                                </Grid>
                                            )}

                                            {this.state.imagenesRemotas.map((img, idx) => (
                                                <Grid item xs={12} sm={4} md={4} key={img.key}>
                                                <Card sx={{ width: '100%', aspectRatio: '1 / 1', position: 'relative' }}>
                                                    <CardMedia
                                                    component="img"
                                                    image={img.url}
                                                    alt={`Imagen remota ${idx + 1}`}
                                                    sx={{ objectFit: 'cover', width: '100%', height: '100%', aspectRatio: '1 / 1' }}
                                                    />
                                                    <CardActions sx={{ position: 'absolute', top: 0, right: 0 }}>
                                                    <Tooltip title="Eliminar imagen del reporte">
                                                        <IconButton color="error" onClick={() => this.handleRemoveImagenRemota(idx)}>
                                                        <FaTrash />
                                                        </IconButton>
                                                    </Tooltip>
                                                    </CardActions>
                                                </Card>
                                                </Grid>
                                            ))}
                                            </Grid>
                                        </Grid>

                                        {/* ==== Subir nuevas imágenes (máx 3 total) ==== */}
                                        <Grid item xs={12} sx={{ mt: 2 }}>
                                            <Typography variant="subtitle2" sx={{ color: '#0468BF', fontSize: '16px', fontWeight: 400, ml: 1 }}>
                                            Adjuntar imágenes (JPG, PNG)
                                            </Typography>

                                            <Button
                                            variant="contained"
                                            component="label"
                                            // deshabilita si ya hay 3 entre remotas + nuevas
                                            disabled={this.state.imagenesRemotas.length + this.state.imagenesAdjuntas.length >= 3}
                                            sx={{ mt: 1 }}
                                            >
                                            Seleccionar imágenes
                                            <input
                                                type="file"
                                                accept="image/*"
                                                multiple
                                                hidden
                                                onChange={this.handleImagenesSeleccionadas}
                                            />
                                            </Button>
                                        </Grid>

                                        {/* ==== Previsualización de imágenes nuevas ==== */}
                                        <Grid item xs={12} sx={{ mt: 2 }}>
                                            <Typography variant="subtitle2" sx={{ color: '#0468BF', fontSize: '16px', fontWeight: 400, ml: 1 }} gutterBottom>
                                            Imágenes seleccionadas
                                            </Typography>
                                            <Grid container spacing={2}>
                                            {this.state.imagenesAdjuntas.map((img, idx) => (
                                                <Grid item xs={12} sm={4} md={4} key={idx}>
                                                <Card sx={{ width: '100%', aspectRatio: '1 / 1', position: 'relative' }}>
                                                    <CardMedia
                                                    component="img"
                                                    image={URL.createObjectURL(img)}
                                                    alt={`Imagen ${idx + 1}`}
                                                    sx={{ objectFit: 'cover', width: '100%', height: '100%', aspectRatio: '1 / 1' }}
                                                    />
                                                    <CardActions sx={{ position: 'absolute', top: 0, right: 0 }}>
                                                    <Tooltip title="Eliminar imagen">
                                                        <IconButton color="error" onClick={() => this.handleRemoveImagen(idx)}>
                                                        <FaTrash />
                                                        </IconButton>
                                                    </Tooltip>
                                                    </CardActions>
                                                </Card>
                                                </Grid>
                                            ))}
                                            </Grid>
                                        </Grid>
                                        </AccordionDetails>
                                        </Accordion>

                                         <Accordion>
                                                             <AccordionSummary
                                                              expandIcon={<ExpandMoreIcon />}
                                                              aria-controls="panel3a-content"
                                                              id="panel3a-header"
                                                            >
                                                              <Typography sx={{
                                                                color: '#0468BF',
                                                                fontSize: '18px',
                                                                fontWeight: 400,
                                                                ml: 1,
                                                              }}>
                                                                Repuestos Recomendados 
                                                              </Typography>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                          <Grid container spacing={2}>
                                            {this.state.repuestos.map((repuesto, index) => (
                                              <Grid item xs={12} sm={6} key={index}>
                                                <TextField
                                                  fullWidth
                                                  label={`Repuesto ${index + 1}`}
                                                  value={repuesto}
                                                  onChange={(e) => this.handleRepuestoChange(index, e.target.value)}
                                                  variant="outlined"
                                                  size="small"
                                                  InputProps={{
                                                    endAdornment: this.state.repuestos.length > 1 && (
                                                      <Tooltip title="Eliminar">
                                                        <IconButton onClick={() => this.handleRemoveRepuesto(index)} edge="end" size="small" color="error">
                                                          <FaTrash />
                                                        </IconButton>
                                                      </Tooltip>
                                                    )
                                                  }}
                                                />
                                              </Grid>
                                            ))}
                                        
                                            {this.state.repuestos.length < 6 && (
                                              <Grid item xs={12}>
                                                <Button
                                                  variant="outlined"
                                                  startIcon={<FaPlus />}
                                                  onClick={this.handleAddRepuesto}
                                                >
                                                  Agregar Repuesto
                                                </Button>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </AccordionDetails>
                                                          </Accordion>

<Accordion>
                    <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                >
                  <Typography sx={{
                    color: '#0468BF',
                    fontSize: '18px',
                    fontWeight: 400,
                    ml: 1,
                  }}>
                    Fecha y Hora
                  </Typography>
                </AccordionSummary>
                   <AccordionDetails>
          <Grid container spacing={2}>
    {/* Fila: Fechas */}
    <Grid item xs={12} sm={6}>
      <TextField
        required
        fullWidth
        type="date"
        name="fecha"
        id="fecha"
        label="Fecha de Realización"
        value={this.state.fecha}
        onChange={this.handleChange}
        helperText={errors.fecha}
        error={Boolean(errors.fecha)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField
        required
        fullWidth
        type="date"
        name="fechafinal"
        id="fechafinal"
        label="Fecha Final"
        value={this.state.fechafinal}
        onChange={this.handleChange}
        helperText={errors.fechafinal}
        error={Boolean(errors.fechafinal)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>

    {/* Fila: Horas */}
    <Grid item xs={12} sm={6}>
      <TextField
        required
        fullWidth
        type="time"
        name="horainicio"
        id="horainicio"
        label="Hora de Inicio"
        value={this.state.horainicio}
        onChange={this.handleChange}
        helperText={errors.horainicio}
        error={Boolean(errors.horainicio)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField
        required
        fullWidth
        type="time"
        name="horafinal"
        id="horafinal"
        label="Hora Final"
        value={this.state.horafinal}
        onChange={this.handleChange}
        helperText={errors.horafinal}
        error={Boolean(errors.horafinal)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>
  </Grid>
                                   </AccordionDetails>
                  </Accordion>

 <Accordion>
                     <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel5a-content"
                  id="panel5a-header"
                >
                  <Typography sx={{
                    color: '#0468BF',
                    fontSize: '18px',
                    fontWeight: 400,
                    ml: 1,
                  }}>
                    Personal que recibe la actividad
                  </Typography>
                </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <FormControl fullWidth size="small">
                                <InputLabel>Método de recepción</InputLabel>
                                <Select
                                  name="metodoRecepcion"
                                  value={this.state.metodoRecepcion || 'manual'}
                                  label="Método de recepción"
                                  onChange={(e) => {
                                    this.handleChange(e);
                                    this.handleMethodChange(e);
                                  }}
                                  error={Boolean(errors.metodoRecepcion)}
                                >
                                  <MenuItem value="manual">Ingreso manual</MenuItem>
                                  <MenuItem value="firma">Firma digital</MenuItem>
                                  <MenuItem value="usuario">Seleccionar usuario</MenuItem>
                                  <MenuItem value="imagen">Cargar imagen</MenuItem>
                                </Select>
                                <FormHelperText>{errors.metodoRecepcion}</FormHelperText>
                              </FormControl>
                            </Grid>
                      
                            {/* ==== Personaliza según el método seleccionado ==== */}
                            {this.state.metodoRecepcion === "manual" && (
                              <>
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    size="small"
                                    label="Nombre de quien recibe la actividad"
                                    name="firmarecibe"
                                    value={this.state.firmarecibe}
                                    onChange={this.handleChange}
                                    error={Boolean(errors.firmarecibe)}
                                    helperText={errors.firmarecibe}
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    size="small"
                                    label="Cargo de quien recibe la actividad"
                                    name="cargorecibe"
                                    value={this.state.cargorecibe}
                                    onChange={this.handleChange}
                                    error={Boolean(errors.cargorecibe)}
                                    helperText={errors.cargorecibe}
                                  />
                                </Grid>
                              </>
                            )}
                      
                            {this.state.metodoRecepcion === "firma" && (
  <>
    {this.state.imagenfirma ? (
      // ✅ Hay firma guardada (viene del reporte o ya se guardó)
      <Grid item xs={12}>
        <Typography sx={{ mb: 1 }}>Firma digital guardada</Typography>
        <Box
          component="img"
          src={this.state.imagenfirma}     // puede ser dataURL o URL remota
          alt="Firma digital"
          sx={{ maxWidth: '100%', maxHeight: 200, border: '1px solid #e0e0e0', borderRadius: 1 }}
        />
        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <Button variant="outlined" color="error" onClick={this.handleRemoveFirmaDigital}>
            Reemplazar / Quitar firma
          </Button>
        </Stack>

        {/* Datos del firmante (editables) */}
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              variant="outlined"
              size="small"
              label="Nombre del firmante"
              name="nombreFirmante"
              value={this.state.nombreFirmante}
              onChange={this.handleChange}
              error={Boolean(errors.nombreFirmante)}
              helperText={errors.nombreFirmante}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              variant="outlined"
              size="small"
              label="Cargo del firmante"
              name="cargoFirmante"
              value={this.state.cargoFirmante}
              onChange={this.handleChange}
              error={Boolean(errors.cargoFirmante)}
              helperText={errors.cargoFirmante}
            />
          </Grid>
        </Grid>
      </Grid>
    ) : (
      // ✍️ No hay firma: muestra el canvas para capturar una nueva
      <>
        <Grid item xs={12}>
          <div className="firma-canvas-container">
            <canvas
              ref={this.canvasRef}
              id="firma-digital-canvas"
              className="firma-canvas"
              width="500"
              height="200"
            />
          </div>
          <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
            <Button variant="outlined" onClick={this.clearSignature}>Limpiar firma</Button>
            <Button variant="contained" onClick={this.saveSignature}>Guardar firma</Button>
          </Stack>
          {errors.firmaDigital && (
            <Typography color="error" sx={{ mt: 1 }}>{errors.firmaDigital}</Typography>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            required
            variant="outlined"
            size="small"
            label="Nombre del firmante"
            name="nombreFirmante"
            value={this.state.nombreFirmante}
            onChange={this.handleChange}
            error={Boolean(errors.nombreFirmante)}
            helperText={errors.nombreFirmante}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            required
            variant="outlined"
            size="small"
            label="Cargo del firmante"
            name="cargoFirmante"
            value={this.state.cargoFirmante}
            onChange={this.handleChange}
            error={Boolean(errors.cargoFirmante)}
            helperText={errors.cargoFirmante}
          />
        </Grid>
      </>
    )}
  </>
)}
                      
                            {this.state.metodoRecepcion === "usuario" && (
                              <>
                                <Grid item xs={12}>
                                  <FormControl fullWidth size="small">
                                    <InputLabel>Usuario que recibe</InputLabel>
                                    <Select
                                      name="usuarioRecibe"
                                      value={this.state.usuarioRecibe || ''}
                                      onChange={this.handleChange}
                                      label="Usuario que recibe"
                                      error={Boolean(errors.usuarioRecibe)}
                                    >
                                      <MenuItem value=""><em>Seleccione un usuario</em></MenuItem>
                                      {this.props.user.usuariosAsistenciales?.map(user => (
                                        <MenuItem key={user.idUsuario} value={user.idUsuario}>
                                          {user.nombre} {user.cargo ? `- ${user.cargo}` : ''}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    <FormHelperText>{errors.usuarioRecibe}</FormHelperText>
                                  </FormControl>
                                </Grid>
                      
                                {this.state.usuarioRecibe && (
                                  <Grid item xs={12}>
                                    <Typography variant="body2" sx={{ mt: 2 }}>
                                      <strong>Nombre:</strong> {this.getUserInfo(this.state.usuarioRecibe, 'nombre')}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Cargo:</strong> {this.getUserInfo(this.state.usuarioRecibe, 'cargo')}
                                    </Typography>
                                  </Grid>
                                )}
                              </>
                            )}
                      
                            {this.state.metodoRecepcion === "imagen" && (
                              <>
                                <Grid item xs={12}>
                                  <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={this.handleImageButtonClick}
                                    disabled={this.state.uploadingImage}
                                  >
                                    {this.state.uploadingImage ? 'Procesando...' : 'Cargar imagen de firma'}
                                  </Button>
                                </Grid>
                      
                                {this.state.imagenFirma && (
                                  <Grid item xs={12}>
                                    <Box
                                      component="img"
                                      src={this.state.imagenFirma}
                                      alt="Vista previa de firma"
                                      sx={{ maxWidth: '100%', maxHeight: 200, mt: 2 }}
                                    />
                                  </Grid>
                                )}
                      
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    size="small"
                                    label="Nombre del firmante"
                                    name="nombreFirmaImagen"
                                    value={this.state.nombreFirmaImagen}
                                    onChange={this.handleChange}
                                    error={Boolean(errors.nombreFirmaImagen)}
                                    helperText={errors.nombreFirmaImagen}
                                  />
                                </Grid>
                      
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    size="small"
                                    label="Cargo del firmante"
                                    name="cargoFirmaImagen"
                                    value={this.state.cargoFirmaImagen}
                                    onChange={this.handleChange}
                                    error={Boolean(errors.cargoFirmaImagen)}
                                    helperText={errors.cargoFirmaImagen}
                                  />
                                </Grid>
                              </>
                            )}
                          </Grid>
                     </AccordionDetails>
                  </Accordion>
                </form>
                  
               
                </DialogContent>
              </div>
            )}

            <DialogActions>
              <MyButton tip="Cerrar" onClick={this.handleClose}>
                <FaArrowLeft className="icon-formulario" />
              </MyButton>

              {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : this.state.aprobado.mensaje ? (
                <MyButton tip="Continuar" onClick={this.handleClose}>
                  <FaCheckCircle className="icon-formulario" />
                </MyButton>
              ) : (
                <MyButton tip="Actualizar Información" onClick={this.handleSubmit}>
                  <FaPlus className="icon-formulario" />
                </MyButton>
              )}
            </DialogActions>
          </Dialog>
        </Fragment>
      </div>
    );
  }
}

EditarMtoPrev.propTypes = {
  editMtoTablaV2: PropTypes.func.isRequired,
  getMtoPrevV2:PropTypes.func.isRequired,
  
  clearErrors: PropTypes.func.isRequired,
  reportemto: PropTypes.object,
  equipoId: PropTypes.string,
  UI: PropTypes.object.isRequired,
  getUsuariosAsistenciales:PropTypes.func.isRequired,
  disabled: PropTypes.bool, 
};

const mapActionsToProps = { editMtoTablaV2,getUsuariosAsistenciales, getMtoPrevV2, clearErrors };

const mapStateToProps = (state) => ({
  equipo: state.data.equipo?.credentials,
  data: state.data,
  user: state.user,
  UI: state.UI
});

export default connect(mapStateToProps, mapActionsToProps)(EditarMtoPrev);
